const defaultResponse = { data: {} }

export class HttpClientMock {
  get = jest.fn(() => Promise.resolve(defaultResponse))
  put = jest.fn(() => Promise.resolve(defaultResponse))
  post = jest.fn(() => Promise.resolve(defaultResponse))
  delete = jest.fn(() => Promise.resolve(defaultResponse))
  defaults = { headers: { common: {} } }

  interceptors = {
    request: {
      use: jest.fn(),
      eject: jest.fn(),
    },
    response: {
      use: jest.fn(),
      eject: jest.fn(),
    },
  }
}



// WEBPACK FOOTER //
// ./src/modules/http-client/__mocks/http-client.service-mock.ts